export const REVIEW_INCOMING_APPLICATIONS_FETCHING =
  'REVIEW_INCOMING_APPLICATIONS_FETCHING';
export const REVIEW_INCOMING_APPLICATIONS_FETCH_ERROR =
  'REVIEW_INCOMING_APPLICATIONS_FETCH_ERROR';
export const REVIEW_INCOMING_APPLICATIONS_GET_APPLICATIONS =
  'REVIEW_INCOMING_APPLICATIONS_SAVE_APPLICATIONS';
export const REVIEW_INCOMING_APPLICATIONS_SET_SYNCLOADING =
  'REVIEW_INCOMING_APPLICATIONS_SET_SYNCLOADING';
export const REVIEW_INCOMING_APPLICATIONS_SYNC_ERROR =
  'REVIEW_INCOMING_APPLICATIONS_SYNC_ERROR';
export const REVIEW_INCOMING_APPLICATIONS_SET_SYNC_ERROR =
  'REVIEW_INCOMING_APPLICATIONS_SET_SYNC_ERROR';
export const REVIEW_INCOMING_APPLICATIONS_SET_FILTERED_DATA =
  'REVIEW_INCOMING_APPLICATIONS_SET_FILTERED_DATA';



// WEBPACK FOOTER //
// ./src/pages/reviewincomingapplications/state/grid/types.js